import { useState } from 'react';

import { useAppState } from '../../../AppStateProvider';
import {
  COMPANY_OVERVIEW_FEATURE_KEY,
  CONTACTS_FEATURE_KEY,
  INSIGHTS_FEATURE_KEY,
  NT_PURCHASE_PAGE_LINK,
} from '../../../domain/gainAccessView';
import { CompanyTabName } from '../../../domain/page';
import { useIsDataCreditsEnabled } from '../../../features/quota/hooks/useIsDataCreditsEnabled';
import { useNTStatusQuery } from '../../../features/user/useNTStatusQuery';
import { useRequestAccessMutation } from '../../../features/user/useRequestAccessMutation';
import { useUserStatus } from '../../../hooks/useUserStatus';
import { ContactUsSuccessModal } from '../../../pages/settings/ContactUsSuccessModal/ContactUsSuccessModal';
import { AppMode, appStore } from '../../../services/appStore';
import { translate } from '../../../services/i18n';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { Modal } from '../../Modal';

import { QuotaButton } from './QuotaButton';
import { StyledCreditsWrapper, StyledUpgradeIconButton } from './styles';
import useCreditsView from './useCreditsView';

export const QuotaView = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();
  const { mode } = useAppState();

  const { isTrialOrAfterTrial, isNoTouch } = useUserStatus();
  const { data: NTStatus } = useNTStatusQuery();

  const [isHookModalOpen, setIsHookModalOpen] = useState(false);

  const requestAccessMutation = useRequestAccessMutation();

  const { isDataCreditsEnabled } = useIsDataCreditsEnabled();

  const { location, shouldShowCredits, quota } = useCreditsView();

  const handleClickUpgrade = () => {
    dispatchTrackEventWithLocation(
      'hooks',
      'upgrade package',
      `upgrade extension top actions/${quota.used}/${quota.remaining}`
    );

    if (NTStatus?.isAllowed) {
      return;
    }
    const featureKey =
      location === CompanyTabName.Insights
        ? INSIGHTS_FEATURE_KEY
        : location === CompanyTabName.Overview
          ? COMPANY_OVERVIEW_FEATURE_KEY
          : CONTACTS_FEATURE_KEY;
    requestAccessMutation.mutate(featureKey);
    setIsHookModalOpen(true);
  };

  const handleClickOnCredits = () => {
    dispatchTrackEventWithLocation('extension top actions', 'see credits', `extension credits/${location}`);
    appStore.setSettingsPage();
  };

  if (!shouldShowCredits) {
    return null;
  }

  return (
    <StyledCreditsWrapper>
      <QuotaButton
        isDataCreditsEnabled={isDataCreditsEnabled}
        quota={quota}
        location={location}
        onClick={mode === AppMode.Extension ? handleClickOnCredits : undefined}
      />

      {isTrialOrAfterTrial || isNoTouch ? (
        <StyledUpgradeIconButton variant="trial" iconName="sparkles-gray" iconSize="12px" onClick={handleClickUpgrade}>
          {NTStatus?.isAllowed ? (
            <a href={NT_PURCHASE_PAGE_LINK} target="_blank" rel="noreferrer">
              {translate('upgrade.button')}
            </a>
          ) : (
            translate('upgrade.button')
          )}
        </StyledUpgradeIconButton>
      ) : null}

      <Modal isOpen={isHookModalOpen} onClose={() => setIsHookModalOpen(false)}>
        <ContactUsSuccessModal />
      </Modal>
    </StyledCreditsWrapper>
  );
};
